import { useState, useEffect } from 'react';
import './work.css';
import Header from '../components/header';
import Footer from '../components/footer';
import ChromaGrid from '../components/ChromaGrid';
import { staticProjectsAPI } from '../api';

const PALETTE = [
  { borderColor: '#5227ff', gradient: 'linear-gradient(145deg, #5227ff 0%, #000 100%)' },
  { borderColor: '#CCFF00', gradient: 'linear-gradient(210deg, #CCFF00 0%, #000 100%)' },
  { borderColor: '#00CCFF', gradient: 'linear-gradient(165deg, #00CCFF 0%, #000 100%)' },
  { borderColor: '#FF6B00', gradient: 'linear-gradient(195deg, #FF6B00 0%, #000 100%)' },
  { borderColor: '#00FF88', gradient: 'linear-gradient(225deg, #00FF88 0%, #000 100%)' },
  { borderColor: '#FF2D6B', gradient: 'linear-gradient(135deg, #FF2D6B 0%, #000 100%)' },
];

function projectToChromaItem(project, index) {
  const { borderColor, gradient } = PALETTE[index % PALETTE.length];
  const techTags = project.techStack
    ? project.techStack.split(',').map(t => t.trim()).filter(Boolean)
    : [];

  return {
    image: project.preview || '',
    title: project.title,
    subtitle: project.description || '',
    handle: techTags.length ? techTags.map(t => `#${t}`).join(' ') : undefined,
    borderColor,
    gradient,
    url: project.previewUrl || project.liveUrl || project.githubUrl || undefined,
    githubUrl: project.githubUrl || undefined,
    liveUrl: project.liveUrl || undefined,
  };
}

function Work() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await staticProjectsAPI.getAll();
        setProjects(data);
      } catch (err) {
        console.error('Failed to fetch projects:', err);
        setError('Не удалось загрузить проекты');
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const chromaItems = projects.map(projectToChromaItem);

  return (
    <div className="work-page">
      <Header />

      <main className="work-main">
        <div className="work-header">
          <span className="section-eyebrow-work">Портфолио</span>
          <h1 className="work-title">Мои работы</h1>
          <p className="work-subtitle">
            Проекты, которые я создал за последние годы
          </p>
        </div>

        {loading && (
          <div className="work-loading">
            <div className="loading-dots">
              <div className="loading-dot" />
              <div className="loading-dot" />
              <div className="loading-dot" />
            </div>
            <span>Загрузка проектов...</span>
          </div>
        )}

        {error && (
          <div className="work-error">
            <span>⚠️ {error}</span>
          </div>
        )}

        {!loading && !error && projects.length > 0 && (
          <div className="work-chroma-wrapper">
            <ChromaGrid
              items={chromaItems}
              radius={350}
              damping={0.45}
              fadeOut={0.6}
              ease="power3.out"
            />
          </div>
        )}

        {!loading && !error && projects.length === 0 && (
          <div className="work-empty">
            <span>Проекты не найдены</span>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}

export default Work;
